import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

export const createClassroom = async createClassroomRequest => {
  const { data } = await apiClient.post('/classroom', createClassroomRequest);
  return data;
};

export const getClassroomData = async () => {
  const { data } = await apiClient.get(`/classroom`);
  return data;
};

export const useClassroomData = () => {
  return useQuery({ queryKey: ['classroomData'], queryFn: getClassroomData });
};

export const getClassroomUsers = async () => {
  const { data } = await apiClient.get('/classroom/users');
  return data;
};

export const renameClassroom = async classroomName => {
  const { data } = await apiClient.put('/classroom', { name: classroomName });
  return data;
};

export const nominatePrefect = async username => {
  const { data } = await apiClient.post('/classroom/prefect', { username });
  return data;
};

export const removePrefect = async username => {
  const { data } = await apiClient.delete('/classroom/prefect', {
    data: { username } // This is the correct way to send data in a DELETE request with axios.
  });
  return data;
};

export const removeUserFromClassroom = async username => {
  const { data } = await apiClient.delete('/classroom/users', {
    data: { users: [username] }
  });
  return data;
};
